// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"d299922f","outerContainer":"e21efdaa","secondaryToolbar":"_5f692a97","doorHangerRight":"_24d11b30","toolbarContainer":"_45ed72a7","toolbarViewerMiddle":"ec6bc183","progressBar":"_75571579","back-to-application":"_9ecd88b4","root":"_1078af1d","icon":"_7ee0f89e","icon--left":"ea73c7a2","icon--right":"_82e95675","textWrapper":"a3c3a32e","chatWrapper":"_50659b1f","text":"_8873c432","text--primary":"dc44468d","text--secondary":"f3e953e1","helperContainer":"c34f9195","bold":"fb4433b6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/index.styl
// module id = 2242
// module chunks = 39